// extracted by mini-css-extract-plugin
module.exports = {"teams":"Team_teams__ug_ri","teams__add":"Team_teams__add__2YQ_O"};